import { v4 as uuidv4 } from "uuid";

Office.onReady((info) => {
  if (info.host === Office.HostType.Outlook) {
    console.log("Office is ready!");
    document.getElementById("sideload-msg").style.display = "none";
    document.getElementById("app-body").style.display = "flex";
    document.getElementById("send-to-dynamics").onclick = () => {
      console.log("Button clicked, calling sendToDynamics...");
      sendToDynamics();
    }

    // Ensure the request result section is hidden initially
    document.getElementById("result").style.display = "none";
  }
});

async function getAttachmentContent(attachmentId) {
  return new Promise((resolve, reject) => {
    Office.context.mailbox.item.getAttachmentContentAsync(attachmentId, (result) => {
      if (result.status === Office.AsyncResultStatus.Succeeded) {
        resolve({
          content: result.value.content,
          contentType: result.value.format, // MIME type or format
        });
      } else {
        reject(result.error);
      }
    });
  });
}

function maskEmail(email) {
  const [localPart, domain] = email.split("@");
  if (localPart.length <= 3) {
    return "*".repeat(localPart.length) + "@" + domain;
  }
  const visible = localPart.slice(0, 3);
  const masked = "*".repeat(localPart.length - 3);
  return `${visible}${masked}@${domain}`;
}

async function uploadAttachmentToS3(fileName, base64Content, contentType, eventId) {
  try {
    // Step 1: Request pre-signed URL
    const presignedResponse = await fetch(API_BASE_URL, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        action: "getPresignedUrl",
        userEmail: Office.context.mailbox.userProfile.emailAddress,
        key: `${eventId}/${Date.now()}_${fileName}`,
      }),
    });

    if (!presignedResponse.ok) {
      throw new Error("Failed to get presigned URL");
    }

    const { presignedUrl } = await presignedResponse.json();

    // Step 2: Convert base64 to binary
    const binaryString = atob(base64Content);
    const len = binaryString.length;
    const uint8Array = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
      uint8Array[i] = binaryString.charCodeAt(i);
    }

    // Step 3: Upload file using pre-signed URL
    const uploadResponse = await fetch(presignedUrl, {
      method: "PUT",
      headers: {
        "Content-Type": contentType || "application/octet-stream",
      },
      body: uint8Array,
    });

    if (!uploadResponse.ok) {
      throw new Error(`S3 upload failed with status ${uploadResponse.status}`);
    }

    // Step 4: Return S3 URL for payload
    const url = new URL(presignedUrl);
    const bucketName = url.hostname.split(".")[0];
    const key = url.pathname.slice(1); // remove leading '/'

    return `https://${bucketName}.s3.ap-southeast-2.amazonaws.com/${key}`;

  } catch (error) {
    console.error(`Error uploading ${fileName}:`, error);
    throw error;
  }
}

async function sendToDynamics() {
  const resultElement = document.getElementById("result");
  const loading = document.getElementById("loading");

  resultElement.style.display = "none";
  loading.style.display = "block";

  const item = Office.context.mailbox.item;
  if (!item) {
    resultElement.innerHTML = `<span style="color: red">❌ No email item detected.</span>`;
    resultElement.style.display = "block";
    loading.style.display = "none";
    return;
  }

  const eventId = `event_${uuidv4()}`;

  item.body.getAsync(Office.CoercionType.Html, async (bodyResult) => {
    if (bodyResult.status !== Office.AsyncResultStatus.Succeeded) {
      resultElement.innerHTML = `<span style="color: red">❌ Unable to read the email body.</span>`;
      resultElement.style.display = "block";
      loading.style.display = "none";
      return;
    }

    const userEmail = Office.context.mailbox.userProfile.emailAddress;
    const maskedEmail = maskEmail(userEmail);
    const senderEmail = item.from?.emailAddress || "Unknown";
    const recipientEmails = Array.isArray(item.to) ? item.to.map(r => r.emailAddress) : [];
    const sentDate = item.dateTimeCreated;

    const attachments = item.attachments || [];
    const attachmentDetails = [];
    const failedUploads = [];

    for (const attachment of attachments) {
      try {
        const { content, contentType } = await getAttachmentContent(attachment.id);
        const s3Url = await uploadAttachmentToS3(attachment.name, content, contentType, eventId);

        attachmentDetails.push({
          name: attachment.name,
          type: attachment.attachmentType,
          size: attachment.size,
          id: attachment.id,
          isInline: attachment.isInline,
          contentType,
          s3Url,
        });
      } catch (error) {
        failedUploads.push(attachment.name);
      }
    }

    const payload = {
      subject: item.subject,
      description: bodyResult.value,
      userEmail: maskedEmail,
      senderEmail,
      recipientEmails,
      attachments: attachmentDetails,
      time: sentDate,
      eventId: attachmentDetails.length ? eventId : "",
    };
    try {
      const response = await fetch(API_BASE_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      if (response.ok) {
        if (failedUploads.length) {
          resultElement.innerHTML = `
            <div class="result-box warning">
              ⚠️ Partial success.<br>Email sent, but these attachments failed:
              <ul>${failedUploads.map(f => `<li>${f}</li>`).join("")}</ul>
            </div>`;
        } else {
          resultElement.innerHTML = `
            <div class="result-box success">
              ✅ Email and attachments successfully synced to Dynamics 365.
            </div>`;
        }
      } else {
        resultElement.innerHTML = `
          <div class="result-box error">
            ❌ Failed to sync with Dynamics 365.
          </div>`;
      }
    } catch (err) {
      console.error("API error:", err);
      resultElement.innerHTML = `<span style="color: red;">❌ Error sending data to Dynamics 365.</span>`;
    }

    loading.style.display = "none";
    resultElement.style.display = "block";

    setTimeout(() => {
      resultElement.style.display = "none";
    }, 7000);
  });
}

